import { IconProps } from "@/types/icons.ts";
import clsx from "clsx";

export const ListStructures = ({
  width = 24,
  height = 24,
  className,
  decorative = false,
  ariaLabel = "List structures",
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M2.257 4.757A.9.9 0 0 1 3 4.5a.9.9 0 0 1 1 1 .9.9 0 0 1-1 1 .9.9 0 0 1-1-1 .9.9 0 0 1 .257-.743m1.486 7.986A.9.9 0 0 0 4 12a.9.9 0 0 0-1-1 1 1 0 1 0 0 2 .9.9 0 0 0 .743-.257M3 17.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 6V5h16v1zm0 6.5h16v-1H6zM22 19H6v-1h16z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};


